import ScreenResizer from "../libs/phaserextension/display/ScreenResizer";
//TODO this might be something to put up in the base class
class ReadinessScreenResizer extends ScreenResizer {
    constructor() {
        super();

        this._pastWidth = window.innerWidth;
        this._pastHeight = window.innerHeight;
    }
    /**
     * Resized based off of the dimensions passed into it, if the game dimensions are larger than the target, the
     * resizer will maintain the target as a safe area, but allow the game to expand to into the bleed area
     * if the screen dimensions require it
     * @type {number}
     * @readonly
     */
    get RESIZE_TARGET_DIMENSIONS() { return 3; }

    resizeByDimensions() {
        let oldScale = this.scaleModifier;

        // take either the target or the target plus the amount beyond it on the y and the x, depending on the higher number
        let tw = Math.max(this._targetWidth, this._targetWidth + (window.innerWidth - this._pastWidth));
        let th = Math.max(this._targetHeight, this._targetHeight + (window.innerHeight - this._pastHeight));

        // prioritize scale based off of which one is the smaller number, if width scale is less than height scale by it
        this.scaleModifier = Math.min(window.innerWidth / tw, window.innerHeight / th);
            
        this.resizeGame(this.scaleModifier, oldScale); // <-- using oldScale seems to stop scale fuctions from invoking eachother every frame.
             
        // retain the past dimensions for the delta resize value
        this._pastWidth = window.innerWidth;
        this._pastHeight = window.innerHeight;
    }

    /**
     * Initializes the ScreenResizer instance. This will set the target resolution,
     * and sets up Phaser.ScaleManager to use custom user scaling functions.
     * @param {Phaser.Game} game
     * @param {number} width
     * @param {number} height
     * @param {number} resizeType
     */
    init(game, targetWidth, targetHeight, resizeType) {
        this.game = game;
        this.resolution = new Phaser.Point(this.game.width, this.game.height);

        this._targetWidth = targetWidth;
        this._targetHeight = targetHeight;

        switch (resizeType) {
            case this.RESIZE_BY_WIDTH:
                this.game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
                this.game.scale.setResizeCallback(this.resizeByWidth, this);
                break;

            case this.RESIZE_BY_HEIGHT:
                this.game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
                this.game.scale.setResizeCallback(this.resizeByHeight, this);
                break;

            case this.RESIZE_TARGET_DIMENSIONS:
                this.game.scale.scaleMode = Phaser.ScaleManager.USER_SCALE;
                if(!Phaser.Device.iOS)
                {
                    this.game.scale.setResizeCallback(this.resizeByDimensions, this);
                }
                else // THIS IS TEMP!!
                {
                    this.game.scale.setResizeCallback(this.resizeByWidth, this);
                }
                
                //window.addEventListener('resize', this.resizeByDimensions.bind(this));
                //window.onload = this.resizeByDimensions.bind(this);
                break;
        }
    }
}

export const screenResizer = new ReadinessScreenResizer();
